import {AppBar, Toolbar} from "@mui/material";

export const PrimaryNavbar = props => {
    const {appbarClasses, color, component, disableGutters, position, toolbarClasses, variant, ...otherProps} = props
    return (
        <AppBar
            classes={{root: appbarClasses}}
            color={color || 'inherit'}
            position={position || 'static'}
            style={{backgroundColor: '#8AC8D5'}}
        >
            <Toolbar
                classes={{root: toolbarClasses}}
                disableGutters={disableGutters || false}
                variant={variant || 'regular'}
                {...otherProps}
            >
                {component}
            </Toolbar>
        </AppBar>
    )
}